export const handleError = (dispatch, type, err) => {
    console.log("::::::: err)");
    dispatch({ type, error: err });
    console.log(err);
    console.log("::::::: err)");
}